import React from 'react'

import SimpleComment from './SimpleComment'
import { useCommentsContext } from '../Hooks/useCommentsContext'

function CommentsList() {
  const { comments } = useCommentsContext()

  return (
    <section className="comments">
      {comments.map((comment) => (
        <SimpleComment
          key={comment.id}
          id={comment.id}
          {...comment.attributes}
        />
      ))}
    </section>
  )
}

export default CommentsList
